import {
  CustomField,
  CustomFieldType,
  CustomFieldValueInput,
} from "@api/graphql/generated/generated-types";

export function buildCustomFieldValues(
  formValues: Record<string, string | number | undefined>,
  customFields: Pick<CustomField, "id" | "type">[]
): CustomFieldValueInput[] {
  const fieldTypeMap = new Map(customFields.map((f) => [f.id, f.type]));

  return Object.keys(formValues)
    .filter((id) => formValues[id] != null)
    .map((fieldId) => {
      const value = formValues[fieldId];
      const fieldType = fieldTypeMap.get(fieldId);

      return {
        fieldId,
        valueText: typeof value === "string" ? value : undefined,
        valueNumber:
          fieldType === CustomFieldType.Number && typeof value === "number"
            ? value
            : undefined,
        valueInteger:
          fieldType === CustomFieldType.Integer && typeof value === "number"
            ? value
            : undefined,
      };
    });
}
